module.exports = __webpack_public_path__ + "static/media/placeholder.88859f81.png";